



















































































































import { Component, Vue, Mixins, Prop, Watch } from 'vue-property-decorator';
import UserMixin from '@/mixins/UserMixin';
import EditViewMixin from '@/mixins/EditViewMixin';
import DeviceViewMixin from '@/mixins/DeviceViewMixin';
import TopMenu from '@/components/TopMenu.vue';
import ResetDeviceButton from '@/components/device/ResetDeviceButton.vue';
import FooterMenu from '@/components/FooterMenu.vue';
import { Client, GetDeviceInfoResponse } from '@/common/apis/DeviceApi';
import ApiProvider from '@/common/apis/ApiProvider';
@Component({
    components: {
        TopMenu,
        FooterMenu,
        ResetDeviceButton,
    },
})
export default class Settings extends Mixins(DeviceViewMixin, UserMixin) {
    @Prop({required: true})
    public deviceNumber: string;

    public info: GetDeviceInfoResponse | null = null;
    public isExpanded: boolean = false;
    public resetLine: string = '';

    public get connections(): string {
        if (!this.info || !this.info.connections) {
            return '';
        }
        return this.info.connections.replace(/\), /gi, ')<br/>');
    }

    public async mounted() {
        const api = ApiProvider.getDeviceApi();
        this.info = await api.getDeviceInfo(this.deviceNumber);
    }

    public async deviceInfoClick() {
        if (!this.isExpanded) {
            this.isExpanded = true;
        } else {
            const api = ApiProvider.getDeviceApi();
            this.info = await api.getDeviceInfo(this.deviceNumber);
        }
    }

    public async restartClick() {
        const api = ApiProvider.getDeviceApi();
        await api.restartDevice(this.deviceNumber);
    }
    // public async resetClick() {
    //     const api = ApiProvider.getDeviceApi();
    //     await api.(this.deviceNumber);
    // }
}
